import React, { Component, Fragment } from "react";
import {
	Form,
	Input,
	Slider,
	Row,
	Col,
	Tabs,
	Select,
	Checkbox,
	Button,
	Radio,
	Tooltip,
	InputNumber,
	Icon
} from "antd";
import co from "co";
import { observer, inject } from "mobx-react";
import { Guides } from "common/guides";
import { locationPrefix } from "common/general";

const FormItem = Form.Item;
const TextArea = Input.TextArea;
const TabPane = Tabs.TabPane;
const Option = Select.Option;
const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;

@Form.create({
	onFieldsChange(props, changedFields) {
		props.onFieldsChange(changedFields);
	},

	mapPropsToFields(props) {
		return props.fields;
	}
})
@observer
class ContentForm extends Component {
	validateForm = () => {
		return new Promise(resolve => {
			this.props.form.validateFieldsAndScroll((err, vals) => {
				resolve(err);
			});
		});
	};
	render() {
		let tier = this.props.tier;
		let imageSection = "";

		if (
			this.props.form.getFieldValue(`content[${tier}].insertImages`) ==
			true
		) {
			let searchForImageSection = "";
			let imagesToInsertSection = "";

			if (
				this.props.form.getFieldValue(
					`content[${tier}].searchForImages`
				) == true
			) {
				searchForImageSection = (
					<FormItem label="Keywords to search for images" style={{ marginBottom: 10 }}>
						{this.props.form.getFieldDecorator(
							`content[${tier}].keywordsForImage`,
							{
								rules: [
									{
										required: true,
										message:
											"Enter keywords to search for images"
									}
								]
							}
						)(<TextArea rows={4} />)}
					</FormItem>
				);
			} else {
				imagesToInsertSection = (
					<FormItem label="Image URLs to insert" style={{ marginBottom: 10 }}>
						{this.props.form.getFieldDecorator(
							`content[${tier}].imagesToInsert`,
							{
								rules: [
									{
										required: true,
										message:
											"Please enter the URLs of images to insert"
									}
								]
							}
						)(<TextArea rows={4} />)}
					</FormItem>
				);
			}

			imageSection = (
				<Fragment>
					<FormItem style={{ marginBottom: 10 }}>
						{this.props.form.getFieldDecorator(
							`content[${tier}].searchForImages`,
							{
								// valuePropName: "checked"
							}
						)(
							<RadioGroup>
								<RadioButton value={true}>
									Search for Images
								</RadioButton>
								<RadioButton value={false}>
									Enter Image URLs
								</RadioButton>
							</RadioGroup>
						)}
					</FormItem>
					{searchForImageSection}
					{imagesToInsertSection}
					<FormItem label="Minimum number of images" style={{ marginBottom: 10 }}>
						{this.props.form.getFieldDecorator(
							`content[${tier}].minImage`,
							{
								rules: [
									{
										required: true,
										message: "Required"
									},
									{
										type: "integer",
										range: {
											min: 0
										},
										message: "Must be greater or equal to 0"
									}
								]
							}
						)(<InputNumber min={0} />)}
					</FormItem>
					<FormItem label="Maximum number of images" style={{ marginBottom: 10 }}>
						{this.props.form.getFieldDecorator(
							`content[${tier}].maxImage`,
							{
								rules: [
									{
										required: true,
										message: "Required"
									},
									{
										type: "integer",
										range: {
											min: 0
										},
										message: "Must be greater or equal to 0"
									}
								]
							}
						)(<InputNumber min={0} />)}
					</FormItem>
					<FormItem label="Image Position">
						{this.props.form.getFieldDecorator(
							`content[${tier}].imagePosition`,
							{
								rules: [
									{
										required: true,
										message: "Please select image position"
									}
								]
							}
						)(
							<Select style={{ width: 200 }}>
								<Option value="Top">Top</Option>
								<Option value="Bottom">Bottom</Option>
								<Option value="Random">Random</Option>
							</Select>
						)}
					</FormItem>
				</Fragment>
			);
		}

		let videoSection = "";

		if (
			this.props.form.getFieldValue(`content[${tier}].insertVideos`) ==
			true
		) {
			let searchForVideosSection = "";
			let videosToInsertSection = "";

			if (
				this.props.form.getFieldValue(
					`content[${tier}].searchForVideos`
				) == true
			) {
				searchForVideosSection = (
					<FormItem label="Keywords to search for videos" style={{ marginBottom: 10 }}>
						{this.props.form.getFieldDecorator(
							`content[${tier}].keywordsForVideo`,
							{
								rules: [
									{
										required: true,
										message:
											"Enter keywords to search for videos"
									}
								]
							}
						)(<TextArea rows={4} />)}
					</FormItem>
				);
			} else {
				videosToInsertSection = (
					<FormItem label="Video URLs to insert" style={{ marginBottom: 10 }}>
						{this.props.form.getFieldDecorator(
							`content[${tier}].videosToInsert`,
							{
								rules: [
									{
										required: true,
										message:
											"Please enter the URLs of videos to insert"
									}
								]
							}
						)(<TextArea rows={4} />)}
					</FormItem>
				);
			}

			videoSection = (
				<Fragment>
					{/* <FormItem style={{ marginBottom: 10 }}>
						{this.props.form.getFieldDecorator(
							`content[${tier}].searchForVideos`,
							{
								// valuePropName: "checked"
							}
						)(
							<RadioGroup>
								<RadioButton value={true}>
									Search for Videos
								</RadioButton>
								<RadioButton value={false}>
									Enter Video URLs
								</RadioButton>
							</RadioGroup>
						)}
					</FormItem>
					{searchForVideosSection} */}
					{videosToInsertSection}
					<FormItem label="Minimum number of videos" style={{ marginBottom: 10 }}>
						{this.props.form.getFieldDecorator(
							`content[${tier}].minVideo`,
							{
								rules: [
									{
										required: true,
										message: "Required"
									},
									{
										type: "integer",
										range: {
											min: 0
										},
										message: "Must be greater or equal to 0"
									}
								]
							}
						)(<InputNumber min={0} />)}
					</FormItem>
					<FormItem label="Maximum number of videos" style={{ marginBottom: 10 }}>
						{this.props.form.getFieldDecorator(
							`content[${tier}].maxVideo`,
							{
								rules: [
									{
										required: true,
										message: "Required"
									},
									{
										type: "integer",
										range: {
											min: 0
										},
										message: "Must be greater or equal to 0"
									}
								]
							}
						)(<InputNumber min={0} />)}
					</FormItem>
					<FormItem label="Video Position">
						{this.props.form.getFieldDecorator(
							`content[${tier}].videoPosition`,
							{
								rules: [
									{
										required: true,
										message: "Please select video position"
									}
								]
							}
						)(
							<Select style={{ width: 200 }}>
								<Option value="Top">Top</Option>
								<Option value="Bottom">Bottom</Option>
								<Option value="Random">Random</Option>
							</Select>
						)}
					</FormItem>
				</Fragment>
			);
		}

		let contentGroups = this.props.contentGroups;
		return (
			<Fragment>
				<FormItem
					label={
						<Tooltip title="Articles will be taken from the selected content group">
							<span>Content Group</span>
						</Tooltip>
					}
					style={{ marginBottom: 10 }}
					colon={false}
				>
					{this.props.form.getFieldDecorator(
						`content[${tier}].contentGroupId`,
						{
							rules: [
								{
									required: true,
									message:
										"You need to select a content group to get articles from"
								}
							]
						}
					)(
						<Select
							style={{ width: "70%" }}
							placeholder="Select a content bucket"
							showSearch
							filterOption={(input, option) =>
								option.props.children
								.toLowerCase()
								.indexOf(input.toLowerCase()) >= 0
							}							
						>
							{contentGroups.map(item => {
								return (
									<Option key={item.id} value={item.id}>
										{item.name}
									</Option>
								);
							})}
						</Select>
					)}
					{' '}
					<a href={Guides["content-groups"]} target="_blank">
						<Icon
							type="question-circle"
							theme="twoTone"
							style={{ fontSize: "22px" }}
						/>
					</a>
					{' '}
					<Button
						type="primary"
						onClick={() => {
							window.open(locationPrefix + "/content-groups");
						}}
					>
						Content Manager
					</Button>
				</FormItem>
				<Row gutter={9}>
					<Col span={6}>
						<FormItem style={{ marginBottom: 10 }}>
							{this.props.form.getFieldDecorator(
								`content[${tier}].insertImages`,
								{
									valuePropName: "checked"
								}
							)(<Checkbox>Insert images to your posts</Checkbox>)}
						</FormItem>
						{imageSection}
					</Col>
					<Col span={6}>
						<FormItem style={{ marginBottom: 10 }}>
							{this.props.form.getFieldDecorator(
								`content[${tier}].insertVideos`,
								{
									valuePropName: "checked"
								}
							)(<Checkbox>Insert video to your posts</Checkbox>)}
						</FormItem>
						{videoSection}
					</Col>
				</Row>
			</Fragment>
		);
	}
}

@inject("rootStore")
@observer
class MainTabs extends Component {
	constructor(props) {
		super(props);
		this.state = {
			activeKey: "tier1"
		};
	}

	setActiveKey = activeKey => {
		this.setState({ activeKey });
	};

	handleTabChange = activeKey => {
		this.setState({ activeKey });
	};

	render() {
		return (
			<Tabs
				tabPosition="left"
				activeKey={this.state.activeKey}
				onChange={this.handleTabChange}
				animated={false}
			>
				{this.props.tabPanes}
			</Tabs>
		);
	}
}

@inject("rootStore")
@observer
class ContentTab extends Component {
	internalForms = [];

	validateForm = () => {
		return co(
			function*() {
				for (let tier = 0; tier < this.internalForms.length; tier++) {
					let internalForm = this.internalForms[tier];
					let result = yield internalForm.validateForm();
					if (result != null) {
						this.mainTabs.setActiveKey(`tier${tier + 1}`);
						return result;
					}
				}
				return null;
			}.bind(this)
		);
		// return new Promise(resolve => {
		// 	this.internalForm.validateForm((err, vals) => {
		// 		resolve(err);
		// 	});
		// });
	};

	onFieldsChange = changedFields => {
		const {
			rootStore: { xwizardStore }
		} = this.props;
		xwizardStore.formChanged(changedFields);
	};

	mapPropsToFields = () => {
		const {
			rootStore: { xwizardStore }
		} = this.props;
		const stateForm = xwizardStore.stateForm;

		let data = {
			content: []
		};

		for (let i = 0; i < stateForm.content.length; i++) {
			let content = stateForm.content[i];
			data.content.push({
				contentGroupId: Form.createFormField(
					content.contentGroupId && content.contentGroupId.value != 0
						? content.contentGroupId
						: { value: undefined }
				),
				insertImages: Form.createFormField(content.insertImages),
				imagePosition: Form.createFormField(content.imagePosition),
				keywordsForImage: Form.createFormField(
					content.keywordsForImage
				),
				searchForImages: Form.createFormField(content.searchForImages),
				imagesToInsert: Form.createFormField(content.imagesToInsert),
				minImage: Form.createFormField(content.minImage),
				maxImage: Form.createFormField(content.maxImage),

				insertVideos: Form.createFormField(content.insertVideos),
				videoPosition: Form.createFormField(content.videoPosition),
				keywordsForVideo: Form.createFormField(
					content.keywordsForVideo
				),
				searchForVideos: Form.createFormField(content.searchForVideos),
				videosToInsert: Form.createFormField(content.videosToInsert),
				minVideo: Form.createFormField(content.minVideo),
				maxVideo: Form.createFormField(content.maxVideo)
			});
		}

		return data;
	};

	render() {
		const fields = this.mapPropsToFields();

		const {
			rootStore: { xwizardStore }
		} = this.props;
		const stateForm = xwizardStore.stateForm;

		let tabPanes = [];
		this.internalForms = [];
		for (let tier = 0; tier < stateForm.content.length; tier++) {
			let tabName = `Tier ${tier + 1}`;
			let tabKey = `tier${tier + 1}`;
			let tabPane = (
				<TabPane tab={tabName} key={tabKey} forceRender={true}>
					<Form>
						<ContentForm
							tier={tier}
							fields={fields}
							contentGroups={xwizardStore.contentGroups}
							onFieldsChange={this.onFieldsChange}
							wrappedComponentRef={internalForm => {
								if (internalForm != null) {
									this.internalForms.push(internalForm);
								}
							}}
						/>
					</Form>
				</TabPane>
			);
			tabPanes.push(tabPane);
		}

		return (
			<MainTabs
				tabPanes={tabPanes}
				ref={mainTabs => {
					if (mainTabs != null) {
						this.mainTabs = mainTabs.wrappedInstance;
					}
				}}
			/>
		);
	}
}

export default ContentTab;
